import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "import-from-axon-evidence",
  courseId: "reports-from-audio",
  order: 6,
  title: "Import from Axon",
  subtitle: "Pull footage from Axon Evidence",
  summary:
    "Pull body-cam footage from Axon Evidence into a case without downloading it first. The transfer runs on the server.",
  learn: [
    "Find and select Axon evidence inside the upload flow",
    "Mix Axon footage with files from your computer",
    "Know when it is safe to leave the page",
  ],
  minutes: 3,
  releasedAt: "2025-06-01T00:00:00.000Z",
  gate: "agency",
  sceneId: "import-from-axon-evidence",
  tourId: "import-from-axon-evidence",
  body: [
    {
      type: "paragraph",
      text: "If your agency admin has connected Axon Evidence on the Integrations tab, the upload modal has an **Add Bodycam Video** button. Evidence streams from Axon to the case without touching your computer, so you do not download a large file just to upload it again.",
    },
    {
      type: "steps",
      items: [
        "Click **New Case**.",
        "Click **Upload Files**, then **Add Bodycam Video**.",
        "In the \"Body Cam Footage\" modal, search with \"Search by title...\" or browse. Items over 4 hours are grayed out.",
        "Click a clip to open its details, then click **Add to Upload**. Repeat for each clip you want; clips you already added show as \"Added\".",
        "Back in the upload modal, set speakers, context, and any footage options on the Axon rows. Add local files too if you have them.",
        "Click **Upload (N files)**.",
      ],
    },
    {
      type: "callout",
      tone: "tip",
      title: "You can leave sooner than you think",
      text: "Local files upload from your browser one at a time, while Axon transfers all start at once on the server. When the local files finish, you can close the tab. The progress toast shows the local upload percentage and how many Axon files are still transferring.",
    },
    {
      type: "paragraph",
      text: "Axon footage follows the same video rules as a local upload. It defaults to **Interaction**, audio is extracted unless you keep the video, and **Analyze the footage** appears only with the video add-on.",
    },
    {
      type: "callout",
      tone: "note",
      title: "No Add Bodycam Video button?",
      text: "Ask your admin to open the agency dashboard, go to **Integrations**, fill in the Axon Evidence settings, then click **Test Connection** and **Save Configuration**.",
    },
    {
      type: "paragraph",
      text: "\"Body-cam footage\" explains those video options in detail.",
    },
  ],
  related: ["body-cam-footage", "the-agency-dashboard", "cancel-or-recover-an-upload"],
};

export default lesson;
